import request, { ResponsePageableData } from '@/libs/request'

/** 设置模型字段 */
export const setModelField = (data?) => request<ResponsePageableData>({ url: '/commonapi/other/setModelField', data })
